import { GenericEventsRouteProvider } from '@wix/data-tools-generic-events';
import { useShowMobileAppCard } from '../../../lib/mobile-app-status';
import { BriefSlot } from '../BriefSlot';
import { ShopifyReconnectBanner } from '../connectors/ShopifyConnectionHealth';
import { AgentsIslandBadge, useAgentsPillReady } from '../AgentsIslandBadge';
import { useChipSlotHolds } from '../chip-morph/ChipSlotContext';
import { MobileAppBanner } from '../catch-up/MobileAppBanner';
import { GreetingDate } from './GreetingDate';
import styles from './MobileHomeHeader.module.css';

// Mobile home aligns to the native app (Figma 6377-22633/22668): a small 16/16
// greeting beside the big date, then the agents island as its own left-aligned
// row below — not up in AppFrame's top bar (AppFrame drops it on home/narrow).
export function MobileHomeHeader({ home2 = false }: { home2?: boolean }) {
  const showQr = useShowMobileAppCard();
  const pillReady = useAgentsPillReady();
  // While a minimized call owns the shared capsule (lib/chip-morph.ts) the pill
  // is not in this row — but the row must keep its height, or the brief and
  // everything below it jump every time a call is shrunk or ended.
  const pillHere = useChipSlotHolds('pill');
  const reserving = pillReady && !pillHere;
  return (
    <div className={styles.root}>
      <div className={styles.greetingRow}>
        <GreetingDate compact />
      </div>
      <div className={`${styles.islandRow}${reserving ? ` ${styles.islandRowReserved}` : ''}`}>
        {reserving ? null : (
          <GenericEventsRouteProvider value="agents-island">
            <AgentsIslandBadge side="start" />
          </GenericEventsRouteProvider>
        )}
      </div>
      {/* Home 2: mobile keeps today's brief hero for now — the redesign is desktop-only
          this pass (a mobile design lands later), so `home2` doesn't change what renders here yet. */}
      <ShopifyReconnectBanner />
      <BriefSlot home2={home2} />
      {/* The get-the-app banner (Figma 13918-214272) rides directly below the morning brief on mobile;
          desktop keeps the QR `MobileAppCard` in its ⅔/⅓ header row. Same gate — a confirmed
          never-had-the-app account only. */}
      {showQr && <MobileAppBanner />}
    </div>
  );
}
